import React from "react";

export const BidStatusLabel = ({bid, bidStatusToColorCompanyMap = {}, brief}) => {
    let [title, subTitle, color, backgroundColor] = bidStatusToColorCompanyMap[bid?.status || "none"];

    title = typeof title === "function" ? title(bid, brief, bid?.providerId) : title;
    subTitle = typeof subTitle === "function" ? subTitle(bid, brief, bid?.providerId) : subTitle;
    color = typeof color === "function" ? color(bid, brief, bid?.providerId) : color;
    backgroundColor =
        typeof backgroundColor === "function" ? backgroundColor(bid, brief, bid?.providerId) : backgroundColor;

    return (
        <div style={{display: "flex", flexDirection: "column", width: "43%", textAlign: "start"}}>
            <span
                style={{
                    color,
                    backgroundColor,
                    maxWidth: "max-content",
                    padding: "0 5px",
                    fontWeight: 500
                }}>
                {title}
            </span>
            {!!subTitle && <div>{subTitle}</div>}
        </div>
    );
};
